import { GoatAwkward, useIntl } from '@capsicum/common';
import { GenericDrawer } from '@capsicum/common-web';

export type NothingToWithdrawDrawerProps = {
	closeModal: () => void;
	testID: string;
};

export const NothingToWithdrawDrawer = ({ closeModal, testID }: NothingToWithdrawDrawerProps) => {
	const { $t } = useIntl();

	const nothingToWithdrawData = {
		buttonText: $t('wallet.withdraw.nothingToWithdrawDrawer.buttonText'),
		description: $t('wallet.withdraw.nothingToWithdrawDrawer.description'),
		image: GoatAwkward,
		testID: testID,
		title: $t('wallet.withdraw.nothingToWithdrawDrawer.title')
	};

	return <GenericDrawer {...nothingToWithdrawData} onButtonPress={closeModal}></GenericDrawer>;
};
